var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-page"},[_c('div',{staticClass:"auth-page__logo text-center pt-8"},[_c('a',{attrs:{"href":_vm.basePath}},[_c('icon-base',{attrs:{"icon":"logo","alt":""}})],1)]),_c('div',{staticClass:"auth-page__content pl-4 pr-4"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }